module.exports = __webpack_public_path__ + "static/media/welcomeLight.4e31a8c5.png";